module.exports = __webpack_public_path__ + "static/media/launch-version-next.cf776f64.jpg";